import { render, staticRenderFns } from "./TrainBoxS.vue?vue&type=template&id=2192a8c2&scoped=true&"
import script from "./TrainBoxS.vue?vue&type=script&lang=ts&"
export * from "./TrainBoxS.vue?vue&type=script&lang=ts&"
import style0 from "./TrainBoxS.vue?vue&type=style&index=0&id=2192a8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2192a8c2",
  null
  
)

export default component.exports